import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@mysaiva/core'
import { workspacePath } from '../../navigation'
import HeroArt from '../../assets/hero-api.svg?react'
import layout from '../../layout/DeveloperPlatformLayout.module.scss'
import styles from './Dashboard.module.scss'
import { GovernanceSection } from './GovernanceSection'
import { UsageSection } from './UsageSection'

/**
 * Workspace landing page (SAIV-11349): hero with the two primary CTAs, the
 * access & governance overview, and the organisation's usage row.
 */
export function DashboardPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles.dashboard} data-testid="dp-page-dashboard">
      <section className={layout.hero} aria-labelledby="dp-hero-title">
        <HeroArt className={layout.heroArt} aria-hidden="true" />
        <h1 id="dp-hero-title">{t('developerPlatform.dashboard.heroTitle')}</h1>
        <p>{t('developerPlatform.dashboard.heroText')}</p>
        <div className={layout.heroActions}>
          <Button
            type="primary"
            icon={<Icon icon="Key" size={16} />}
            onClick={() => navigate(`${workspacePath('api-keys')}?create=1`)}
            data-testid="dp-cta-api-key"
          >
            {t('developerPlatform.dashboard.ctaApiKey')}
          </Button>
          <Button
            icon={<Icon icon="ArrowRight" size={16} />}
            onClick={() => navigate(workspacePath('api-openapi-preview'))}
            data-testid="dp-cta-explore"
          >
            {t('developerPlatform.dashboard.ctaExplore')}
          </Button>
        </div>
      </section>
      <GovernanceSection />
      <UsageSection />
    </div>
  )
}
